import { ReactNode } from 'react';
import { Content } from './Content/Content';
import { useStyles } from './Layout.styles';
import { Navigation } from './Navigation/Navigation';

interface Props {
  children: ReactNode;
}

export function Layout({ children }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navigation />
      <Content>{children}</Content>
    </div>
  );
}
